<template>
  <div>
    <div v-show="showborder" class="fixed-r"></div>
    <div
      v-show="showborder"
      class="fixed-l"
      :style="showborder ? 'border-left: 1px solid #e7e8ea;' : ''"
    ></div>
    <div class="class-room-view" v-if="eventList.length > 0">
      <div class="calss-room-top" ref="classroomTop">
        <div class="title">教室</div>
        <div class="room-name-right">
          <div class="class-room-name" ref="classroomName">
            <div
              class="row-top"
              v-for="(classroom, i) in eventList"
              :key="classroom.classroom_id"
              :style="`width:${colWidthArray[i] * 205}px`"
            >
              <div class="name">
                <div>
                  {{ classroom.name }}
                </div>
                <div class="link" @click="toWeekView(classroom.classroom_id)">
                  预览空闲时间
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="class-room-info">
        <div class="info-left">
          <div
            v-for="(item, index) in timeRangeHoursEnd - timeRangeHoursStart"
            :key="index"
            class="hour"
            :id="`timejump-${item + timeRangeHoursStart - 1}`"
          >
            <div
              class="classroom-time"
              :style="`height:${rowHeight[index]}px;`"
            >
              <p class="time-slot">
                {{
                  item + timeRangeHoursStart - 1 >= 10
                    ? item + timeRangeHoursStart - 1
                    : "0" + (item + timeRangeHoursStart - 1)
                }}:00
              </p>
              <p class="course-statistics">
                共
                <span
                  :class="
                    totalTimeCourse[item + timeRangeHoursStart - 1] === 0
                      ? ''
                      : 'mwow-green'
                  "
                >
                  {{ totalTimeCourse[item + timeRangeHoursStart - 1] }}
                </span>
                课次
              </p>
            </div>
          </div>
        </div>
        <div class="class-room-bottom" ref="classroomContTop">
          <div class="info-right" ref="classroomContName">
            <div
              v-for="(item, index) in timeRangeHoursEnd - timeRangeHoursStart"
              :key="index"
              class="class-info"
              :id="`classes-${item + timeRangeHoursStart - 1}`"
            >
              <div
                class="row"
                v-for="(classroom, ind) in eventList"
                :key="classroom.classroom_id"
                :style="`min-width:${colWidthArray[ind] * 205}px`"
                :id="`class-course-${ind}`"
              >
                <div class="time">
                  <div
                    v-for="it in classroom.lesson_list.filter((lesson) => {
                      let sHour = Number(lesson.start_time.slice(0, 2));
                      return (
                        sHour >= item + timeRangeHoursStart - 1 &&
                        sHour < item + timeRangeHoursStart
                      );
                    })"
                    :key="it.lesson_id"
                    :style="`
                      background-color:${
                        it.roll_call_status === 2 ? '#b8b8b8' : it.course.color
                      }; 
                      width:${199}px;margin:0 4px 0 0;
                      cursor: pointer;
                    `"
                    :class="it.in_holiday === 1 ? 'bias-bgc' : ''"
                  >
                    <slot :lesson="it"></slot>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="scroll-bar" ref="scrollBardiv" v-show="showScrollBar">
        <div
          :style="`width:${scrWidth}px;`"
          class="scroll-bar-in"
          ref="scrollBarX"
          @mousedown.stop="handleDown"
        ></div>
      </div>
    </div>
    <div class="no-classroom" v-else>
      <img
        class="person"
        src="https://wowsite.musicwow.com/teaching_system_frontend/images/integral/no-data.png"
        width="101"
        height="154"
      />
      <p class="text">暂无教室</p>
    </div>
  </div>
</template>
<script>
// import lessonDialog from "../lessonDialog.vue";
// import displayItem from "../lessonCalendar/displayItem.vue";
import eventBus from "@/utils/bus";

export default {
  name: "storeScheduleWeekView",
  components: {
    // lessonDialog,
    // displayItem,
  },
  // @Prop() originEvents!: any[];
  // @Prop() originTimeRange!: any[];
  props: ["originEvents", "originTimeRange"],
  // @Watch("originEvents", { immediate: false, deep: false })
  // originEventsChange(n: any[]) {
  //   // 数组传入，刷新视图
  //   this.handleRender(n);
  //   // 时间段展示范围
  //   this.setShowingArea();
  //   this.$nextTick(() => {
  //     this.getClassroomView();
  //   });
  // }
  watch: {
    originEvents: {
      handler(n, o) {
        // 数组传入，刷新视图
        this.handleRender(n);
        // 时间段展示范围
        this.setShowingArea();
        this.$nextTick(() => {
          this.getClassroomView();
        });
      },
      immediate: false,
      deep: false,
    },
  },
  data() {
    return {
      eventList: [],
      timeRangeHoursStart: 9,
      timeRangeHoursEnd: 21,
      viewMode: 1,
      showbtn: false,
      notLeftClick: true,
      notRightClick: false,
      colWidthArray: [],
      totalTimeCourse: [], // 时间段课时数
      showNavgation: true, // 展示时间导航
      rowHeight: [], // 每一行的高度
      downShift: false, // 是否按下了shift键
      num: 100,
      showScrollBar: true, // 显示滚动条
      showborder: false,
      divScrollLeft: false, // 判断是点击滚动还是快捷键滚动
      scrWidth: 100, // 滚动条宽度
      classRoomNameScrollTop: 0, // 教室课表的教室名称宽度
    };
  },
  beforeDestory() {
    const el = document.getElementById("layout-content");
    el.removeEventListener("scroll", () => {});
    // document.removeEventListener("keydown", () => {});
    // document.addEventListener("keyup", () => {});
  },
  methods: {
    handleDown(e) {
      document.addEventListener("selectstart", (e) => {
        e.preventDefault();
      });
      const downDiv = this.$refs["scrollBarX"];
      const scrollDiv = this.$refs["scrollBardiv"];
      const cl_t_t = this.$refs["classroomTop"];
      const cl_t_n = this.$refs["classroomName"];
      const cl_c_t = this.$refs["classroomContTop"];
      const cl_c_n = this.$refs["classroomContName"];
      // 获取超出视窗的宽度
      const overstepWidth =
        cl_t_n.clientWidth + 152 - this.classRoomNameScrollTop;
      // 获取滚动条可滚动的宽度
      const scrollableWidth = scrollDiv.clientWidth - downDiv.clientWidth;
      // 获取滚动的比例
      const scrollScale = overstepWidth / scrollableWidth;
      // 算出鼠标相对元素的位置
      const disX = e.clientX - downDiv.offsetLeft;
      document.onmousemove = (e) => {
        this.divScrollLeft = true;
        //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        const left = e.clientX - disX;
        // 判断是否在滚动区域内滚动
        if (left >= scrollableWidth) {
          cl_t_n.scrollLeft = overstepWidth;
          cl_c_n.scrollLeft = overstepWidth;
          if (this.scrWidth > 0) {
            downDiv.style.left = scrollDiv.clientWidth - this.scrWidth + "px";
          } else {
            downDiv.style.left = scrollableWidth + "px";
          }
          return;
        } else {
          cl_t_n.scrollLeft = left * scrollScale;
          cl_c_n.scrollLeft = left * scrollScale;
          this.num = left * scrollScale;
        }
        if (left <= 0) {
          cl_t_n.scrollLeft = 0;
          cl_c_n.scrollLeft = 0;
          downDiv.style.left = 1 + "px";
          return;
        }
        // 移动当前元素
        downDiv.style.left = left + "px";
      };
      document.onmouseup = (e) => {
        // 鼠标弹起不再移动
        document.onmousemove = null;
        //预防鼠标弹起来后还会循环（即预防鼠标放上去的时候还会移动）
        document.onmouseup = null;
        this.divScrollLeft = false;
        document.removeEventListener("selectstart", () => {});
      };
    },
    getClassroomView() {
      const downDiv = this.$refs["scrollBarX"];
      const scrollDiv = this.$refs["scrollBardiv"];
      const cl_t_n = this.$refs["classroomName"];
      const name = this.$refs["classroomTop"];
      const cl_c_t = this.$refs["classroomContTop"];
      const cl_c_n = this.$refs["classroomContName"];
      const el = document.getElementById("layout-content");
      const wrap = document.getElementById("search-form");
      this.classRoomNameScrollTop = name.clientWidth;
      el.addEventListener("scroll", () => {
        if (el.scrollTop >= wrap.clientHeight + 128) {
          name.classList.add("top-regular");
          this.showborder = true;
        } else {
          name.classList.remove("top-regular");
          this.showborder = false;
        }
      });
      // 获取右边每一行的高度
      const heightArr = [];
      for (let i = this.timeRangeHoursStart; i < this.timeRangeHoursEnd; i++) {
        heightArr.push(document.getElementById(`classes-${i}`)?.clientHeight);
      }
      if (heightArr) {
        this.rowHeight = heightArr;
      }

      // 获取右侧课表宽度
      let timeSlotCourseWidth = 0; // 每个时间段的课次宽度
      for (let i = 0; i < this.eventList.length; i++) {
        timeSlotCourseWidth += document.getElementById(
          `class-course-${i}`
        )?.clientWidth;
      }
      // 判断每个课次的宽度有没有超过一屏
      if (el.clientWidth < timeSlotCourseWidth) {
        this.showScrollBar = true;
      } else {
        this.showScrollBar = false;
      }
      // 重新渲染宽度
      const obj = {};
      for (let i = this.timeRangeHoursStart; i < this.timeRangeHoursEnd; i++) {
        obj[`a${i}`] = document.getElementById(`classes-${i}`);
      }
      const num = Object.keys(obj);
      for (const item in obj) {
        obj[item].style.width = `${timeSlotCourseWidth + num.length / 2}px`;
      }
      // 根据表格实际超出的宽度设置滚动条的宽度
      const beyondWidth = timeSlotCourseWidth - cl_c_t.clientWidth;
      const scrollBarSurplusWidth = beyondWidth / 10;
      this.scrWidth = 800 - scrollBarSurplusWidth;
      cl_c_n.addEventListener("scroll", (e) => {
        // 获取超出视窗的宽度
        const overstepWidth = timeSlotCourseWidth - cl_c_t.clientWidth;
        // 获取滚动条可滚动的宽度
        const scrollableWidth = scrollDiv.clientWidth - downDiv.clientWidth;
        // 获取滚动的比例
        const scrollScale = overstepWidth / scrollableWidth;
        cl_t_n.style.marginLeft = `-${cl_c_n.scrollLeft}px`;
        if (this.divScrollLeft === false) {
          downDiv.style.left = cl_c_n.scrollLeft / scrollScale + "px";
        }
      });
    },

    setShowingArea() {
      if (this.originTimeRange.length === 2) {
        this.timeRangeHoursStart = Number(this.originTimeRange[0].slice(0, 2));
        this.timeRangeHoursEnd =
          Number(this.originTimeRange[1].slice(0, 2)) + 1;
      }
    },
    handleRender(arr) {
      const originData = arr || this.originEvents;
      const result = originData.map((item) => {
        if (item.date_list[0] && item.date_list[0].lesson_list) {
          item.date_list[0].lesson_list.map((lesson) => {
            // 计算课时宽度layout_width
            if (this.originTimeRange.length > 0) {
              const startTime = this.originTimeRange[0].slice(0, 2) + ":00:00";
              const rangeStart = new Date(
                (lesson.date + " " + startTime).replace(/-/g, "/")
              ).getTime();
              const endTime = this.originTimeRange[1].slice(0, 2) + ":00:00";
              const rangeEnd =
                new Date(
                  (lesson.date + " " + endTime).replace(/-/g, "/")
                ).getTime() +
                60 * 60 * 1000;
              const lseeonStart = new Date(
                (lesson.date + " " + lesson.start_time).replace(/-/g, "/")
              ).getTime();
              const lessonEnd = new Date(
                (lesson.date + " " + lesson.end_time).replace(/-/g, "/")
              ).getTime();
              lesson.layout_width =
                (
                  ((lessonEnd - lseeonStart) * 100) /
                  (rangeEnd - rangeStart)
                ).toFixed(2) + "%";
              // 计算课时左边距layout_left
              lesson.layout_left =
                (
                  ((lseeonStart - rangeStart) * 100) /
                  (rangeEnd - rangeStart)
                ).toFixed(2) + "%";
            }
          });
        }
        return {
          ...item.classroom,
          lesson_list: item.date_list[0] ? item.date_list[0].lesson_list : [],
        };
      });
      this.eventList = result;
      this.colWidthArray = [];
      const totalArr = [];
      this.eventList.map((item) => {
        const timeArr = [];
        for (let i = 0; i < 24; i++) {
          timeArr.push(0);
          totalArr.push(0);
        }
        let x = 1; //单小时内课时最大数
        // some code
        item.lesson_list.map((it) => {
          const hours = Number(it.start_time.slice(0, 2));
          timeArr[hours] += 1;
          totalArr[hours] += 1;
        });
        const newArr = timeArr.sort((a, b) => a - b);
        if (newArr[newArr.length - 1] > 0) {
          x = newArr[newArr.length - 1];
        } else {
          x = 1;
        }
        this.colWidthArray.push(x);
      });
      this.totalTimeCourse = totalArr;
      // 判断整个时间段是否有数据
      const nArr = [...totalArr];
      const newArr = nArr.sort((a, b) => a - b);
      if (newArr[newArr.length - 1] > 0) {
        this.showNavgation = true;
      } else {
        this.showNavgation = false;
      }
    },
    toWeekView(classRoom_id) {
      const obj = {
        num: 2,
        cr_id: classRoom_id,
        day_time: this.originEvents[0].date_list[0].date,
      };
      eventBus.$emit("to-classroom-go-week-view", obj);
    },
  },
};
</script>

<style lang="scss" scoped>
.class-room-view {
  border: 1px solid #e7e8ea;
  .calss-room-top {
    z-index: 1000;
    width: 100%;
    overflow: hidden;
    display: flex;
    .title {
      color: #5c5d5e;
      text-align: center;
      z-index: 999;
      flex: 0 0 150px;
      height: 45px;
      line-height: 45px;
      background-color: #f2f6fa;
      border-bottom: 1px solid #e7e8ea;
      border-right: 1px solid #e7e8ea;
    }
    .room-name-right {
      .class-room-name {
        height: 45px;
        text-align: center;
        color: #5c5d5e;
        white-space: nowrap;
        line-height: 22px;
        .row-top {
          display: inline-block;
          border-bottom: 1px solid #e7e8ea;
          border-right: 1px solid #e7e8ea;
          background-color: #f2f6fa;
          padding-left: 5px;
          .name {
            display: block;
            height: 45px;
            .link {
              color: #07d1aa;
              cursor: pointer;
            }
          }
        }
        &:last-child {
          border-right: none;
        }
      }
    }
  }
  .class-room-info {
    display: flex;
    .info-left {
      width: 152px;
      .hour {
        font-size: 12px;
        color: #5c5d5e;
        min-height: 60px;
        box-sizing: border-box;
        .classroom-time {
          width: 150px;
          text-align: center;
          border-right: 1px solid #e7e8ea;
          border-bottom: 1px solid #e7e8ea;
          .time-slot {
            padding-top: 8px;
          }
          .course-statistics {
            padding-top: 8px;
          }
        }
        .time {
          margin-top: -1px;
          min-width: 150px;
          display: flex;
          height: 100%;
          text-align: center;
          border-bottom: 1px solid #e7e8ea;
        }
        .row {
          padding: 5px 0 5px 5px;
          border-right: 1px solid #e7e8ea;
        }
      }
    }
    .class-room-bottom {
      overflow: hidden;
      .info-right {
        overflow-x: scroll;
        .class-info {
          display: flex;
          min-height: 60px;
          font-size: 12px;
          color: #5c5d5e;
          line-height: 60px;
          border-bottom: 1px solid #e7e8ea;
          .time {
            min-width: 150px;
            display: flex;
            text-align: center;
          }
          .row {
            padding: 5px 0 5px 5px;
            border-right: 1px solid #e7e8ea;
          }
        }
      }
      .info-right::-webkit-scrollbar {
        height: 0px;
      }
    }
  }
  &:hover {
    .scroll-bar {
      visibility: visible;
    }
  }
}
.top-regular {
  position: fixed;
  top: 54px !important;
  .el-tabs__content {
    z-index: 9999;
  }
}
.scroll-bar {
  overflow: hidden;
  padding: 0 5px;
  box-sizing: border-box;
  visibility: visible;
  position: fixed;
  bottom: 20px;
  left: 50%;
  background-color: #eef3f6;
  border-radius: 12px;
  height: 14px;
  width: 800px;
  transform: translateX(-50%);
  .scroll-bar-in {
    cursor: pointer;
    position: relative;
    top: 2px;
    border-radius: 12px;
    width: 100px;
    background-color: #a7a7a7;
    height: 10px;
  }
}
.no-classroom {
  width: 100%;
  position: relative;
  min-height: 500px;
  .line {
    position: absolute;
    top: 75px;
    left: 50%;
    margin-left: -380px;
  }
  .person {
    position: absolute;
    top: 141px;
    left: 50%;
    margin-left: -50px;
  }
  .text {
    font-size: 12px;
    color: #5c5d5e;
    position: absolute;
    top: 305px;
    left: 50%;
    margin-left: -33px;
  }
}
.fixed-r {
  position: fixed;
  top: 54px;
  right: 0;
  background-color: #eef3f6;
  width: 16px;
  height: 46px;
  z-index: 1;
}
.fixed-l {
  position: fixed;
  top: 55px;
  right: 16px;
  height: 46px;
  width: 12px;
  background-color: #fff;
  z-index: 1;
}
.element::-webkit-scrollbar {
  height: 0 !important;
}
</style>
